var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractArrival(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.78161V14.74C5 14.9669 5.15284 15.1654 5.37224 15.2234L13.75 17.4375L24.4827 20.2884C25.2933 20.5037 26.2921 20.4562 26.6507 19.698C26.9373 19.0919 26.811 18.434 26.5067 17.9311C26.2164 17.4512 25.6631 17.2323 25.1249 17.0748L19.5719 15.4509C19.41 15.4035 19.2829 15.2778 19.2339 15.1164L16.1431 4.95246C16.0929 4.78762 15.9615 4.6602 15.7952 4.61524L14.3805 4.23289C14.0626 4.147 13.75 4.38636 13.75 4.71558V13.2264C13.75 13.5542 13.4398 13.7934 13.1228 13.7099L8.06339 12.3785C7.90609 12.3371 7.77875 12.2218 7.72203 12.0694L6.90167 9.86463C6.84567 9.71415 6.72081 9.59971 6.56602 9.55701L5.63296 9.29961C5.31457 9.21178 5 9.45132 5 9.78161Z",
    fill: "#595959",
    stroke: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 26.75H27.25",
    stroke: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractArrival);
export default __webpack_public_path__ + "static/media/contract-arrival.bd8b36e21973876156535f97158f2c01.svg";
export { ForwardRef as ReactComponent };